<div class="expiring-documents-table__column-picker">
  <label class="custom-mat-select_table-column-label">{{ 'general.table.label.column' | translate }}:</label>
  <mat-form-field class="custom-mat-form-field custom-mat-select_table-column-picker" floatLabel="never">
    <mat-label>{{ 'general.table.label.select_column' | translate }}:</mat-label>
    <img matSuffix class="custom-mat-select_table-column-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-select [(ngModel)]="isActiveTableTab" [(value)]="isActiveTableTab">
      <mat-option value="document">{{ 'general.table.label.document' | translate }}</mat-option>
      <mat-option value="doc_type">{{ 'general.table.label.type' | translate }}</mat-option>
      <mat-option value="expiry_date">{{ 'general.table.label.expiry_date' | translate }}</mat-option>
      <mat-option value="updated_at">{{ 'general.table.label.updated_at' | translate }}</mat-option>
      <mat-option value="actions">{{ 'general.table.label.actions' | translate }}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div class="expiring-documents-table__container">
  <artemis-loading-spinner *ngIf="isLoading"></artemis-loading-spinner>
  <div class="expiring-documents-table__wrapper">
    <table class="custom-mat-table expiring-documents-table custom-mat-table_first-column" mat-table matSort
           [dataSource]="expiringDocumentsDataSource" (matSortChange)="sortExpiringDocs($event)">

      <ng-container matColumnDef="customer">
        <th class="expiring-documents-table__column-customer-name" mat-header-cell *matHeaderCellDef>{{ 'general.table.label.belongs_to' | translate }}</th>
        <td class="expiring-documents-table__column-customer-name" mat-cell *matCellDef="let expiringDocument"
            [title]="expiringDocument.record.name || ''">
          <span>
            {{expiringDocument.record.name || '-'}}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="document">
        <th class="expiring-documents-table__column-document-link" mat-header-cell *matHeaderCellDef
            [ngClass]="{'mat-cell__column-active': isActiveTableTab === 'document'}">
          {{ 'general.table.label.document' | translate }}
        </th>
        <td class="expiring-documents-table__column-document-link" mat-cell *matCellDef="let expiringDocument"
            [ngClass]="{'mat-cell__column-active': isActiveTableTab === 'document'}">
          <a class="link expiring-documents-table__view-document-link" [href]="expiringDocument.document"
             title="View expiring document" target="_blank">
            <img class="themified-white-icon expiring-documents-table__view-document-icon" src="/assets/icons/magnifying-glass-icon.png"/>
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="doc_type">
        <th class="expiring-documents-table__column-document-type" mat-header-cell *matHeaderCellDef mat-sort-header
            [ngClass]="{'mat-cell__column-active': isActiveTableTab === 'doc_type'}">
          {{ 'general.table.label.type' | translate }}
        </th>
        <td class="expiring-documents-table__column-document-type" mat-cell *matCellDef="let expiringDocument" [title]="expiringDocument.docType || ''"
            [ngClass]="{'mat-cell__column-active': isActiveTableTab === 'doc_type'}">
          <span>{{expiringDocument.docType || '-'}}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="expiry_date">
        <th class="expiring-documents-table__column-expiry-date" mat-header-cell *matHeaderCellDef mat-sort-header
            [ngClass]="{'mat-cell__column-active': isActiveTableTab === 'expiry_date'}">
          {{ 'general.table.label.expiry_date' | translate }}
        </th>
        <td class="expiring-documents-table__column-expiry-date" mat-cell *matCellDef="let expiringDocument"
            [title]="expiringDocument.expiryDate ? (expiringDocument.expiryDate | date:'dd/MM/yyyy') : '-'"
            [ngClass]="{'mat-cell__column-active': isActiveTableTab === 'expiry_date'}">
          {{expiringDocument.expiryDate ? (expiringDocument.expiryDate | date:'dd/MM/yyyy') : '-'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="updated_at">
        <th class="expiring-documents-table__column-updated-date" mat-header-cell *matHeaderCellDef mat-sort-header
            [ngClass]="{'mat-cell__column-active': isActiveTableTab === 'updated_at'}">
          {{ 'general.table.label.last_updated' | translate }}
        </th>
        <td class="expiring-documents-table__column-updated-date" mat-cell *matCellDef="let expiringDocument"
            [title]="expiringDocument.updatedAt ? ((expiringDocument.updatedAt | date:'dd/MM/yyyy \'at\' h:mm:ss a') + ' by ' + (expiringDocument.updatedBy?.name || '-')) : ''"
            [ngClass]="{'mat-cell__column-active': isActiveTableTab === 'updated_at'}">
          {{expiringDocument.updatedAt ? (expiringDocument.updatedAt | date:'dd/MM/yyyy \'at\' h:mm:ss a') : ''}} by <span class="uppercase-text">{{expiringDocument.updatedBy ? expiringDocument.updatedBy?.name || '--' : ''}}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th class="expiring-documents-table__column-actions" mat-header-cell *matHeaderCellDef
            [ngClass]="{'mat-cell__column-active': isActiveTableTab === 'actions'}">
          {{ 'general.table.label.actions' | translate }}
        </th>
        <td class="expiring-documents-table__column-actions" mat-cell *matCellDef="let expiringDocument"
            [ngClass]="{'mat-cell__column-active': isActiveTableTab === 'actions'}">
          <a class="link" (click)="navigateToCustomer(expiringDocument)" title="Edit Documents">
            <img class="themified-white-icon expiring-documents-table__icon expiring-documents-table__icon_edit" src="/assets/icons/edit-icon.png"/>
          </a>
          <img class="themified-white-icon expiring-documents-table__icon" src="/assets/icons/minus-icon-white.png" title="Dismiss notification"
               (click)="dismissNotification(expiringDocument)"/>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <div class="table-empty" *ngIf="expiringDocuments && expiringDocuments.length === 0">
    {{ 'dashboard.task_list.message.no_document' | translate }}
  </div>
  <mat-paginator class="custom-mat-paginator" (page)="newTablePageHandler($event)" showFirstLastButtons
                 [length]="expiringDocumentsCount" [pageSizeOptions]="pageSizeOptions" [pageSize]="preferredExpiringDocumentTablePageSize">
  </mat-paginator>
</div>
